/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiUpdateListSelectorGroupCommand
 */
export interface InternalApiUpdateListSelectorGroupCommand {
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateListSelectorGroupCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateListSelectorGroupCommand
     */
    selectorCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiUpdateListSelectorGroupCommand
     */
    subscribedSelectorOptions: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiUpdateListSelectorGroupCommand
     */
    enabledSelectorOptions: Array<string>;
}

/**
 * Check if a given object implements the InternalApiUpdateListSelectorGroupCommand interface.
 */
export function instanceOfInternalApiUpdateListSelectorGroupCommand(value: object): value is InternalApiUpdateListSelectorGroupCommand {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('selectorCode' in value) || value['selectorCode'] === undefined) return false;
    if (!('subscribedSelectorOptions' in value) || value['subscribedSelectorOptions'] === undefined) return false;
    if (!('enabledSelectorOptions' in value) || value['enabledSelectorOptions'] === undefined) return false;
    return true;
}

export function InternalApiUpdateListSelectorGroupCommandFromJSON(json: any): InternalApiUpdateListSelectorGroupCommand {
    return InternalApiUpdateListSelectorGroupCommandFromJSONTyped(json, false);
}

export function InternalApiUpdateListSelectorGroupCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateListSelectorGroupCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selectorCode': json['selectorCode'],
        'subscribedSelectorOptions': json['subscribedSelectorOptions'],
        'enabledSelectorOptions': json['enabledSelectorOptions'],
    };
}

export function InternalApiUpdateListSelectorGroupCommandToJSON(json: any): InternalApiUpdateListSelectorGroupCommand {
    return InternalApiUpdateListSelectorGroupCommandToJSONTyped(json, false);
}

export function InternalApiUpdateListSelectorGroupCommandToJSONTyped(value?: InternalApiUpdateListSelectorGroupCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'selectorCode': value['selectorCode'],
        'subscribedSelectorOptions': value['subscribedSelectorOptions'],
        'enabledSelectorOptions': value['enabledSelectorOptions'],
    };
}

